// Client-side wrappers for admin API endpoints (replaces useServerFn)

export async function adminListUsers() {
  const res = await fetch('/api/admin_users?action=list', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Request failed');
  return json;
}

export async function adminCreateUser(data: { email: string; password: string }) {
  const res = await fetch('/api/admin_users?action=create', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to create user');
  return json;
}

export async function adminUnlockUser(data: { user_id: string }) {
  const res = await fetch('/api/admin_users?action=unlock', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to unlock user');
  return json;
}

export async function adminDeleteUser(data: { user_id: string }) {
  const res = await fetch('/api/admin_users?action=delete', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to delete user');
  return json;
}

export async function changeOwnPassword(data: { new_password: string }) {
  const res = await fetch('/api/auth_actions?action=change-password', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to change password');
  return json;
}

export async function recordFailedLogin(data: { email: string }) {
  const res = await fetch('/api/auth_actions?action=record-failed-login', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Request failed');
  return json;
}

export async function clearFailedAttempts() {
  const res = await fetch('/api/auth_actions?action=clear-failed-attempts', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Request failed');
  return json;
}

export async function logAction(data: {
  action: string;
  entity?: string;
  entity_id?: string;
  metadata?: Record<string, any>;
}) {
  const res = await fetch('/api/audit', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to log action');
  return json;
}

export async function createInvoice(data: {
  ticket_id: string;
  lines: any[];
  total_ht: number;
  sent_to: string;
}) {
  const res = await fetch('/api/invoices', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${localStorage.getItem('auth.token') || ''}`
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to create invoice');
  return json;
}
